export var WireWithdrawalStatusEnum;
(function (WireWithdrawalStatusEnum) {
    WireWithdrawalStatusEnum["SUBMITTED"] = "submitted";
    WireWithdrawalStatusEnum["PENDING"] = "pending";
    WireWithdrawalStatusEnum["AWAITING_MANUAL_SUBMISSION"] = "awaiting_manual_submission";
    WireWithdrawalStatusEnum["AWAITING_MANUAL_APPROVAL"] = "awaiting_manual_approval";
    WireWithdrawalStatusEnum["REJECTED"] = "rejected";
    WireWithdrawalStatusEnum["ACCEPTED"] = "accepted";
    WireWithdrawalStatusEnum["PROCESSING"] = "processing";
})(WireWithdrawalStatusEnum || (WireWithdrawalStatusEnum = {}));
//# sourceMappingURL=wire-withdrawal-status.enum.js.map